import {
  MagnifyingGlassIcon,
  StarFilledIcon,
  StarIcon,
} from "@radix-ui/react-icons";
import { Flex, IconButton, TextField } from "@radix-ui/themes";
import { forwardRef } from "react";

type FilterSectionProps = {
  showSavedOnly: boolean;
  hasShowSavedButton: boolean;
  onFilterToggle: () => void;
};

export const BasicFilterSection = forwardRef<
  HTMLDivElement,
  FilterSectionProps
>(({ showSavedOnly, onFilterToggle, hasShowSavedButton }, ref) => {
  const renderShowSavedButton = () => {
    if (!hasShowSavedButton) {
      return null;
    }

    return (
      <IconButton
        variant="ghost"
        color="gray"
        size="1"
        mr="1"
        onClick={onFilterToggle}
      >
        {showSavedOnly ? (
          <StarFilledIcon width={16} height={16} />
        ) : (
          <StarIcon width={16} height={16} />
        )}
      </IconButton>
    );
  };
  return (
    <Flex
      ref={ref}
      className="h-12 w-64"
      position="absolute"
      align="end"
      justify="between"
      p="2"
    >
      <TextField.Root placeholder="Search" variant="soft" size="1" disabled>
        <TextField.Slot>
          <MagnifyingGlassIcon height="16" width="16" />
        </TextField.Slot>
      </TextField.Root>
      {renderShowSavedButton()}
    </Flex>
  );
});

export default BasicFilterSection;
